import { loginRequest } from "./auth-config.ts";
import { msalInstance } from "./initialize-auth.ts";

export const getAccessToken = async () => {
  const account = msalInstance.getActiveAccount();

  if (!account) {
    throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
  }

  const response = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: account,
  });

  return response;
};

export const authFetch = async (...args: Parameters<typeof fetch>) => {
  const [url, options] = args;
  const headers = new Headers(options?.headers);

  const accessTokenResponse = await getAccessToken();

  const bearer = `Bearer ${accessTokenResponse.accessToken}`;
  headers.append("Authorization", bearer);

  return fetch(url, { ...options, headers });
};
